// more.js
import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
	constructor(m) {
		super(m);
		this.container = document.getElementById("ajax-posts");
		this.loadMoreBtn = document.getElementById("load-more");
		this.type = this.loadMoreBtn.dataset.type;
		this.currentPage = parseInt(this.loadMoreBtn.dataset.page);
		this.maxPages = parseInt(this.loadMoreBtn.dataset.max);
		this.isLoading = false;
		this.loadingText = this.loadMoreBtn.dataset.loading;
		this.loadText = this.loadMoreBtn.dataset.load;
		this.currentLanguage = document.documentElement.lang;
		this.activeFilters = '';
	}

	init() {
		this.loadMoreBtn.addEventListener("click", () => this.loadMore());

		// Marcar que el usuario navega desde este listing hacia un post.
		// El flag se consume en loadSavedPosts para saber si restaurar o limpiar.
		this.container.addEventListener('click', (e) => {
			if ( e.target.closest('a') ) {
				sessionStorage.setItem('art_from_listing', '1');
			}
		});

		document.addEventListener('cal:filters-changed', (e) => {
			const { qs, maxPages } = e.detail || {};
			if (this.setFilters) this.setFilters(qs || '');
			this.currentPage = 1;
			this.maxPages = parseInt(maxPages || this.maxPages);
			this.loadMoreBtn.dataset.page = 1;
			this.loadMoreBtn.dataset.max = this.maxPages;
			this.loadMoreBtn.style.display = this.maxPages > 1 ? '' : 'none';
		});


		this.loadSavedPosts();
	}

	setFilters(queryString) {
		this.activeFilters = queryString || '';
		this.currentPage = 1;
		this.loadMoreBtn.dataset.page = 1;
	}

	async loadMore(replace = false) {
		if (this.isLoading || this.currentPage >= this.maxPages) return;

		this.isLoading = true;
		this.loadMoreBtn.textContent = this.loadingText;

		const prevCount = this.container.children.length;

		try {
			const qs = `action=load_more_posts&page=${this.currentPage + 1}&type=${this.type}` + (this.activeFilters ? `&${this.activeFilters}` : '');
			const response = await fetch(art.ajaxurl, {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: qs,
			});
			if (!response.ok) throw new Error('Network response was not ok');
			const data = await response.json();

			if (data.success) {
				this.container.insertAdjacentHTML('beforeend', data.data.html);

				const newItems = Array.from(this.container.children).slice(prevCount);
				newItems.forEach(item => item.classList.add('fade-up'));

				this.currentPage++;
				this.loadMoreBtn.dataset.page = this.currentPage;
				this.maxPages = parseInt(data.data.max_pages) || this.maxPages;

				this.saveCurrentState();

				if (this.currentPage >= this.maxPages) {
					this.loadMoreBtn.style.display = 'none';
				} else {
					this.loadMoreBtn.style.display = '';
				}
			}
		} catch (error) {
			console.error('Error loading more posts:', error);
		} finally {
			this.isLoading = false;
			this.loadMoreBtn.textContent = this.loadText;
		}
	}

	loadSavedPosts() {
		const savedType = sessionStorage.getItem('savedType');
		const savedPath = sessionStorage.getItem('savePath');

		// Consumir el flag (se escribe al clicar un post desde este listing).
		const fromListing = sessionStorage.getItem('art_from_listing');
		sessionStorage.removeItem('art_from_listing');

		// Solo restaurar si: venimos de un post (flag activo) Y el path y tipo coinciden.
		if ( ! fromListing || savedType !== this.type || savedPath !== window.location.pathname ) {
			this.clearState();
			return;
		}

		const savedPosts    = sessionStorage.getItem( 'savedPosts' );
		const savedPage     = sessionStorage.getItem( 'savedPage' );
		const savedMaxPages = sessionStorage.getItem( 'savedMaxPages' );
		const savedLanguage = sessionStorage.getItem( 'savedLanguage' );
		const savedFilters  = sessionStorage.getItem( 'savedFilters' ) || '';

		if ( savedPosts && savedPage && savedLanguage ) {
			this.container.innerHTML      = savedPosts;
			this.currentPage              = parseInt( savedPage );
			this.activeFilters            = savedFilters;
			this.loadMoreBtn.dataset.page = this.currentPage;

			if ( savedMaxPages ) {
				this.maxPages                = parseInt( savedMaxPages );
				this.loadMoreBtn.dataset.max = this.maxPages;
			}

			// Actualizar visibilidad del botón según el estado restaurado.
			this.loadMoreBtn.style.display = this.currentPage >= this.maxPages ? 'none' : '';
		}
	}

	clearState() {
		sessionStorage.removeItem( 'savedPosts' );
		sessionStorage.removeItem( 'savedPage' );
		sessionStorage.removeItem( 'savedMaxPages' );
		sessionStorage.removeItem( 'savedLanguage' );
		sessionStorage.removeItem( 'savePath' );
		sessionStorage.removeItem( 'savedType' );
		sessionStorage.removeItem( 'savedFilters' );
	}

	saveCurrentState() {
		sessionStorage.setItem( 'savedPosts',    this.container.innerHTML );
		sessionStorage.setItem( 'savedPage',     this.currentPage );
		sessionStorage.setItem( 'savedMaxPages', this.maxPages );
		sessionStorage.setItem( 'savedLanguage', this.currentLanguage );
		sessionStorage.setItem( 'savePath',      window.location.pathname );
		sessionStorage.setItem( 'savedType',     this.type );
		sessionStorage.setItem( 'savedFilters',  this.activeFilters );
	}
}
